import Reflux from 'reflux';
import TeamData from 'shared/data/Team';
import EventData from 'shared/data/Event';
import ShowData from 'shared/data/Show';
import ItemSetListData from 'shared/data/ItemSetList';

const async = { asyncResult: true };

const GlobalElementActions = Reflux.createActions({
  populate: async,
  populateElementSet: async,
  populateGlobalElementSets: async,
  populateGlobalElementTags: async,
  populateGlobalElementRows: async,
  populateGlobalElementTagCounts: async,
  activateForTeam: async,
  rowsSearch: {},
  rowsClearSearch: {},
  migrateAllEventShowCategoriesToEventGlobalElementLabels: async,
});

GlobalElementActions.activateForTeam.listenAndPromise(
  TeamData.activateGlobalElementManager,
);

GlobalElementActions.populateGlobalElementSets.listenAndPromise(
  EventData.getGlobalElementManagerElementSets,
);

GlobalElementActions.populateElementSet.listenAndPromise(ItemSetListData.get);

GlobalElementActions.populateGlobalElementTags.listenAndPromise(
  EventData.getGlobalElementLabels,
);

GlobalElementActions.migrateAllEventShowCategoriesToEventGlobalElementLabels.listenAndPromise(
  EventData.migrateAllEventShowCategoriesToEventGlobalElementLabels,
);

GlobalElementActions.populateGlobalElementTagCounts.listenAndPromise(
  EventData.getGlobalElementManagerElementSetRowLabelCounts,
);

/**
 * @param teamId
 * @param eventId
 * @param showId
 * @returns {*}
 */
const loadGlobalElements = (teamId, eventId, showId) => {
  return Promise.all([
    ShowData.get(teamId, eventId, showId),
    ItemSetListData.get(teamId, eventId, showId),
  ]).then((results) => {
    return {
      show: results[0],
      itemSetList: results[1],
    };
  });
};

GlobalElementActions.populateGlobalElementRows.listenAndPromise(
  loadGlobalElements,
);

export default GlobalElementActions;
